import React, { Component } from "react";
import reactCSS from "reactcss";
import ReactFitText from "react-fittext";

import { colors } from "assets";

class CardValue extends Component {
  static defaultProps = {
    compressor: 1.1
  };

  getElement(styles) {
    const fitElement = (
      <ReactFitText compressor={this.props.compressor}>
        <p style={styles.value}>{this.props.children}</p>
      </ReactFitText>
    );
    const defaultElement = <p style={styles.value}>{this.props.children}</p>;
    return this.props.fit ? fitElement : defaultElement;
  }

  render = () => {
    const styles = reactCSS(
      {
        default: {
          value: {
            margin: 0,
            display: "block",
            color: "#555",
            fontWeight: 500,
            fontFamily: "Roboto",
            fontSize: "28px"
          }
        },
        small: {
          value: {
            fontSize: "20px"
          }
        },
        positive: {
          value: {
            color: colors.secondary.dark
          }
        },
        negative: {
          value: {
            color: colors.accent.dark
          }
        }
      },
      this.props,
      this.state
    );

    return (
      <div
        className="card-value"
        style={Object.assign({}, styles.container, this.props.style)}
      >
        {this.getElement(styles)}
      </div>
    );
  };
}

export default CardValue;



// WEBPACK FOOTER //
// ./src/components/support/card/card-value.js